// API Configuration - centralized base URL
const getBaseURL = () => {
  return 'https://teras-7d3o.onrender.com';
};

export const API_BASE_URL = getBaseURL();

